import React, { useEffect } from "react"
import BackgroundAuthentication from "../../components/Lystface/Common/BackgroundAuthentication"
import ForgotPassForm from "../../components/Lystface/ForgotPassword/ForgotPassForm"
import ForgotPasswordLayout from "../../components/Lystface/Helper/ForgotPassword/ForgotPasswordLayout"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import { appConstants } from "../../constants/app_constants"
import PasswordUpdatedLayout from "../../components/Lystface/Helper/ForgotPassword/PasswordUpdated/PasswordUpdatedLayout"
import NewPasswordForm from "../../components/Lystface/ForgotPassword/NewPassword/NewPasswordForm"
import VerfiedPage from "./VerfiedPage"
import { resetForgotPswdResponseMsg, userForgetPasswordReset } from "../../store/actions"
import { CustomToast } from "../../components/Lystface/Common/CustomToast"

const ForgotPassword = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(userForgetPasswordReset())

    }
  }, [])

  document.title = `Forgot-Password | ${appConstants.cName}`

  const ForgetPasswordState = state => state.ForgetPassword
  const ForgotPasswordProperties = createSelector(
    ForgetPasswordState,
    ForgotPassword => ({
      loading: ForgotPassword.loading,
      forgotPasswordErrorMessage: ForgotPassword.forgotPasswordErrorMessage,
      forgotPasswordError: ForgotPassword.forgotPasswordError,
      user: ForgotPassword.user,
      linkSend: ForgotPassword.linkSend,
    })
  )
  const { user, linkSend, loading, forgotPasswordErrorMessage, forgotPasswordError } = useSelector(ForgotPasswordProperties)

  useEffect(() => {
    if (forgotPasswordErrorMessage !== null) {
      CustomToast({
        message: forgotPasswordErrorMessage,
        status: forgotPasswordError ? 'failure' : 'success',
        closeToast: () => {
          console.log('Toast closed');
        },
      })
      dispatch(resetForgotPswdResponseMsg())
    }

  }, [forgotPasswordError, forgotPasswordErrorMessage])

  return (
    <>
      {linkSend ? (
        <ForgotPasswordLayout loading={loading} />

      ) : (
        <BackgroundAuthentication form={<ForgotPassForm />} />
      )}


    </>
  )
}

export default ForgotPassword
